<template>
  <div class="user-module w-full">
    <div class="flex mt-8 w-full">
      <div class="flex w-4/5">
        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="name">Ime</label>
            <input
                tabindex="1"
                id="name"
                class="form-control"
                :class="{ _error: validationErrors.name}"
                type="text"
                v-model="form.name"
            >
            <span class="error-message" v-if="validationErrors.name" v-text="validationErrors.name[0]"></span>
          </div>
          <div v-if="!adminData.id" class="form-group">
            <label for="password">Lozinka</label>
            <input
                tabindex="4"
                id="password"
                class="form-control"
                :class="{ _error: validationErrors.password}"
                type="password"
                v-model="form.password"
            >
            <span class="error-message" v-if="validationErrors.password" v-text="validationErrors.password[0]"></span>
          </div>

          <div v-if="adminData.id" class="bg-gray-card py-8 px-12 mt-8">
            <button
                class="password-input"
                :class="{ active: showInputs }"
                @click="showInputs = !showInputs"
            >Promjena lozinke
            </button>
            <div
                class="flex flex-col w-full px-4 password-group"
                :class="{ _show: showInputs }"
            >
              <div class="form-group mt-6">
                <label for="password">Nova lozinka</label>
                <input
                    tabindex="4"
                    id="password"
                    class="form-control"
                    :class="{ _error: validationErrors.password }"
                    type="password"
                    placeholder="********"
                    v-model="form.password"
                    autocomplete="off"
                >
                <span class="error-message" v-if="validationErrors.password"
                      v-text="validationErrors.password[0]"></span>
              </div>
              <div class="form-group">
                <label for="password_confirmation">Ponovite novu lozinku</label>
                <input
                    tabindex="5"
                    id="password_confirmation"
                    class="form-control"
                    :class="{ _error: validationErrors.password }"
                    type="password"
                    placeholder="********"
                    v-model="form.password_confirmation"
                    autocomplete="off"
                >
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="last_name">Prezime</label>
            <input
                tabindex="2"
                id="last_name"
                class="form-control"
                :class="{ _error: validationErrors.last_name}"
                type="text"
                v-model="form.last_name"
            >
            <span class="error-message" v-if="validationErrors.last_name" v-text="validationErrors.last_name[0]"></span>
          </div>
          <div v-if="!adminData.id" class="form-group">
            <label for="password_confirmation">Ponovite lozinku</label>
            <input
                tabindex="5"
                id="password_confirmation"
                class="form-control"
                :class="{ _error: validationErrors.password_confirmation}"
                type="password"
                v-model="form.password_confirmation"
            >
          </div>
        </div>
        <div class="flex flex-col px-6 w-1/3">
          <div class="form-group">
            <label for="email">E-mail</label>
            <input
                tabindex="3"
                id="email"
                class="form-control"
                :class="{ _error: validationErrors.email}"
                type="text"
                v-model="form.email"
            >
            <span class="error-message" v-if="validationErrors.email" v-text="validationErrors.email[0]"></span>
          </div>
        </div>
      </div>
      <div class="flex justify-start items-end w-1/5">
        <div class="flex flex-col">
          <button
              class="btn primary"
              @click="submitForm()"
          >Spremi
          </button>
        </div>
      </div>
    </div>
    <div>
      <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
    </div>
    <response
        v-if="showResponse"
        :data="responseData"
    ></response>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Response from './Response'

export default {
  components: {
    vSelect,
    Response,
  },

  props: {
    adminData: {
      type: Object,
      default: () => ({})
    },
    typeList: {
      type: Array,
      default: () => ([])
    },
    statusList: {
      type: Array,
      default: () => ([])
    },
  },

  data() {
    return {
      form: {
        name: '',
        last_name: '',
        email: '',
        status: 'Aktivan',
        type: '',
      },
      showInputs: false,
      validationErrors: {},
      redirectMessage: '',
      showResponse: false,
      responseData: {},
    }
  },

  created() {
    this.showLoader();
    // Set the inputs to values to given user data
    if (this.adminData.id) {
      _.forEach(this.form, (item, key) => {
        switch (key) {
          default:
            this.form[key] = this.adminData[key]
            break;
        }
      })
    }
    setTimeout(() => {
      this.hideLoader();
    }, 500);
  },

  methods: {
    // Submit the form to create a new user
    submitForm() {
      this.showLoader();
      let formData = new FormData();
      let endpoint = '';

      // Append all form items
      _.forEach(this.form, (item, key) => {
        formData.append(key, item)
      })

      // Conditionaly add method to form submit
      if (this.adminData.id) {
        formData.append("_method", 'PATCH');
      }

      // Sets the endpoint with data for store/update depending on create or update
      if (this.adminData.id) {
        let data = {
          setting: this.adminData.id,
        }
        console.log(data);
        endpoint = route('settings.update', data)
      } else {
        endpoint = route('settings.store')
      }

      // Send the formData to user controller store/update function depending on endpoint
      axios.post(endpoint, formData)
          .then((response) => {
            if (response.status === 200) {
              this.responseData = response.data.data
              this.showResponse = true

              setTimeout(() => {
                this.hideLoader();
                window.location.href = route('settings.index')
              }, 2000);
            }
          })
          .catch((error) => {
            if (typeof (error.response) !== 'undefined')
              this.validationErrors = error.response.data.errors

            console.error(error);
            this.hideLoader();
          });
    },
  }
}
</script>
